import React, { useEffect, useRef, useState } from "react";
import { LeftOutlined, RightOutlined, StarOutlined } from "@ant-design/icons";
import "./HeaderCarousel.scss"
import { Button, Card } from "antd";
import DishAndDetails from "./DishAndDetails";
import { useNavigate } from "react-router-dom";


const foodItems = [
    { name: "Pizza", image: "https://source.unsplash.com/124x130/?pizza" },
    { name: "Burger", image: "https://source.unsplash.com/124x130/?burger" },
    { name: "Pasta", image: "https://source.unsplash.com/124x130/?pasta" },
    { name: "Ice Cream", image: "https://source.unsplash.com/124x130/?icecream" },
    { name: "Sandwich", image: "https://source.unsplash.com/124x130/?sandwich" },
    { name: "Fries", image: "https://source.unsplash.com/124x130/?fries" },
    { name: "Sushi", image: "https://source.unsplash.com/124x130/?sushi" },
    { name: "Pizza", image: "https://source.unsplash.com/124x130/?pizza" },
    { name: "Burger", image: "https://source.unsplash.com/124x130/?burger" },
    { name: "Pasta", image: "https://source.unsplash.com/124x130/?pasta" },
    { name: "Ice Cream", image: "https://source.unsplash.com/124x130/?icecream" },
    { name: "Sandwich", image: "https://source.unsplash.com/124x130/?sandwich" },
    { name: "Fries", image: "https://source.unsplash.com/124x130/?fries" },
    { name: "Sushi", image: "https://source.unsplash.com/124x130/?sushi" },
  ];
interface Featured {
    title: String
};

const Featured = ({title}:Featured) => {
  const scrollRef = useRef<HTMLDivElement>(null); // specify the type here
  const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const navigate = useNavigate();

  const updateScrollButtons = () => {
      if (!scrollRef.current) return;
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
    };
  
    const scrollLeft = () => {
      if (!scrollRef.current) return;
      scrollRef.current.scrollBy({ left: -600, behavior: "smooth" });
    };
  
    const scrollRight = () => {
      if (!scrollRef.current) return;
      scrollRef.current.scrollBy({ left: 600, behavior: "smooth" });
    };
  
    useEffect(() => {
      const el = scrollRef.current;
      if (!el) return;
  
      updateScrollButtons(); // Check on mount
      el.addEventListener("scroll", updateScrollButtons);
      window.addEventListener("resize", updateScrollButtons);
  
      return () => {
        el.removeEventListener("scroll", updateScrollButtons);
        window.removeEventListener("resize", updateScrollButtons);
      };
    }, []);

    const onClick =()=>{
      navigate(`/restaurant/1`)
    }
  return (
    <div style={{ position: "relative", padding: "20px 0px" }}>
    
    <div className="header-text">{title}</div>

      <div className="scroll-see">

        <div
        style={{ marginRight: 8 }} className="see-all"> See All</div>
        
        <Button
                  shape="circle"
                  icon={<LeftOutlined />}
                  style={{ marginRight: 8 }}
                  onClick={scrollLeft}
                  disabled={!canScrollLeft}
                />
                <Button
                  shape="circle"
                  icon={<RightOutlined />}
                  onClick={scrollRight}
                  disabled={!canScrollRight}
                />
      </div>

      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth"
        style={{
            display: "flex",
            overflowX: "hidden",
            overflowY:"hidden",
            scrollBehavior: "smooth",
            paddingTop: "40px", // push down to avoid buttons
            gap: 20
        
          }}
      >
        {foodItems.map((item, index) => (
          <DishAndDetails dish={item}
          index={index}
          itemClick = {onClick}
          />
        ))}
      </div>
    </div>
  );
};

export default Featured;
